import React, { PureComponent } from 'react';
import {PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend} from 'recharts';
import PropTypes from "prop-types";

const colors = ['#DC143C', '#8884d8', '#FFBB28', '#FF8042', '#004481'];
const RADIAN = Math.PI / 180;

class SimplePieChart extends PureComponent {

    render () {
        return (
            <ResponsiveContainer width="100%" height={400}>
                <PieChart width={400} height={400}>
                    <Pie
                        data={this.props.data}
                        dataKey="Valor"
                        nameKey="Nombre"
                        cx="50%"
                        cy="50%"
                        innerRadius={20}
                        outerRadius={80}
                        fill="#8884d8"
                        label={(entry) => `${entry.name}: ${entry.value} (${(entry.percent * 100).toFixed(2)}%)`}
                    >
                        {this.props.data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
        );
    }
}

export default SimplePieChart;
